export default "__VITE_ASSET__e59e90c2__"